import {ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {ConfirmComponent} from "../../common/components/confirm/confirm.component";
import {UpdateCheckService} from "../../common/services/update-check.service";

@Component({
    selector: "app-main",
    template: `
        <common-confirm></common-confirm>
        <common-spinner></common-spinner>
        <common-update-notice></common-update-notice>
        <router-outlet></router-outlet>
    `,
    styles: [
        `
                         app-main {
                             display: block;
                             width: 100%;
                             height: 100%;
                         }
                     `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit {

    @ViewChild(ConfirmComponent, {static: false})
    public confirm: ConfirmComponent;

    public constructor(private updateCheck: UpdateCheckService) {
    }

    public ngOnInit(): void {
        this.updateCheck.init();
    }
}
